export default __webpack_public_path__ + "images/LR.364ea38.png";